import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '产品服务'
          }
        }, {
          path: '/software/pharma',
          name: 'software-pharma',
          component: resolve => require(['@/view/Software_pharma'], resolve),
          meta: {
            title: '派美制药'
          }
        }, {
          path: '/software/healthcare',
          name: 'software-healthcare',
          component: resolve => require(['@/view/Software_healthcare'], resolve),
          meta: {
            title: '派美保健'
          }
        }, {
          path: '/software/devices',
          name: 'software-devices',
          component: resolve => require(['@/view/Software_devices'], resolve),
          meta: {
            title: '灵舟器械'
          }
        }, {
          path: '/software/smartTown',
          redirect: '/service/smartTown'
        }, {
          path: '/software/bigData',
          redirect: '/service/bigData'
        }, {
          path: '/software/health',
          redirect: '/software/healthcare'
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '研发中心'
          }
        }, {
          path: '/service/smartTown',
          name: 'service-smartTown',
          component: resolve => require(['@/view/Software_smartTown'], resolve),
          meta: {
            title: '一类新兽药研发管线'
          }
        }, {
          path: '/service/bigData',
          name: 'service-bigData',
          component: resolve => require(['@/view/Software_bigData'], resolve),
          meta: {
            title: '高端制剂研发平台'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/companygroups',
          name: 'companygroups',
          component: resolve => require(['@/view/CompanyGroup'], resolve),
          meta: {
            title: '公司团队'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js